import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../css/StructureTab.css';
import { API_URL, ENDPOINTS } from '../../../constants/api';
import { getToken } from '../../../utils/TokenUtils';

function StructureTab({ table }) {
  const [columns, setColumns] = useState([]);
  const token = getToken(); // assuming you store and retrieve the token like this

  useEffect(() => {
    const fetchStructure = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/${ENDPOINTS.SQL}/structure/${table}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setColumns(response.data);
      } catch (error) {
        console.error('Error fetching structure:', error);
      }
    };

    if (table) fetchStructure();
  }, [table]);

  return (
    <div className="structure-tab">
      <h3>Structure of `{table}`</h3>
      <table className="table">
        <thead>
          <tr>
            <th>Field</th>
            <th>Type</th>
            <th>Collation</th>
            <th>Null</th>
            <th>Key</th>
            <th>Default</th>
            <th>Extra</th>
            <th>Privileges</th>
            <th>Comment</th>
          </tr>
        </thead>
        <tbody>
          {columns.map((col, i) => (
            <tr key={i}>
              <td>{col.Field}</td>
              <td>{col.Type}</td>
              <td>{col.Collation || '-'}</td>
              <td>{col.Null}</td>
              <td>{col.Key}</td>
              <td>{col.Default !== null ? col.Default : 'NULL'}</td>
              <td>{col.Extra}</td>
              <td>{col.Privileges}</td>
              <td>{col.Comment}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default StructureTab;
